import { IBidCycleOcV3, IBidCycleOcV3Comentario, IUpdateBidCycleOcV3, IUpdateBidCycleOcV3All, IUpdateBidCycleOcV3AllResponse } from '@app/models/BidCycleOrdemCompraModel';
import api from '../api';


const controllerName = 'BidCycleItemOcV3';

export const getByOrdemCompra = (ordemCompraId: string) =>
  api.get<IBidCycleOcV3[]>(`${controllerName}?ordemCompraId=${ordemCompraId}`);

export const getComentarioBybidCycleOcV3 = (bidCycleOcV3Id: string) =>
  api.get<IBidCycleOcV3Comentario[]>(`${controllerName}/${bidCycleOcV3Id}/comentario`);

export const updateAllByList = (all: IUpdateBidCycleOcV3All) =>
  api.put<IUpdateBidCycleOcV3AllResponse>(`${controllerName}/all`, all);

export const ajusteDatasBidCycleItemOcV3ByRealizado = (ordemCompraId: string) =>
  api.get<IBidCycleOcV3[]>(`${controllerName}/ajusteDatasBidCycleItemOcV3ByRealizado?ordemCompraId=${ordemCompraId}`);
